import { motion } from "framer-motion";

export default function SimpleFooter() {
  return (
    <footer className="bg-white/90 dark:bg-white/10 backdrop-blur-md border-t border-gray-200/50 dark:border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <motion.p
            className="text-sm text-gray-600 dark:text-gray-400"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            © {new Date().getFullYear()} de5.ai. All rights reserved.
          </motion.p>
        </div>
      </div>
    </footer>
  );
}
